import { Box, HStack, Icon, Separator, Spacer, Stack, useBreakpointValue } from '@chakra-ui/react'
import type { FC } from 'react'
import { MdSyncDisabled } from 'react-icons/md'

import { Tooltip } from '@app/components/ui/tooltip'
import type useGetObject from '@app/hooks/useGetObject'
import DrawerHeaderActions from '@app/pages/strategies/components/drawer/drawerHeaderActions'
import CardTitle from '@app/shared/cards/components/cardTitle'
import { DomainObjectType } from '@app/shared/cards/components/cardTypeSection'
import Source from '@app/shared/entity/source'
import PageHeaderSection from '@app/shared/layout/pageHeaderSection'
import ICON_MAP, { COLOR_MAP } from '@app/utils/iconMap'

interface Props {
  entity: ReturnType<typeof useGetObject<'entity'>>
  strategyId: string | null
}

const Header: FC<Props> = ({ entity, strategyId }) => {
  const { hasEditedHeadline, sourceName } = entity

  return (
    <PageHeaderSection>
      <Stack>
        <HStack pl={4}>
          <DomainObjectType title="Work" icon={ICON_MAP.Work} color={COLOR_MAP.Entity} />
          <Spacer />
          <DrawerHeaderActions objId={entity.id} objType={entity.classType} strategyId={strategyId} />
        </HStack>
        <Box pl={4}>
          <Source entity={entity} asButton={false} />
        </Box>
        <Separator />
      </Stack>
      <Stack gap={4} px={4}>
        <Box position="relative">
          {hasEditedHeadline && !['web', 'api'].includes(sourceName) && (
            <Box position="absolute" top="-14px" right={0} zIndex={2}>
              <Tooltip content="This title has been edited and will not update on remote changes" showArrow>
                <Icon color="fg.warning" boxSize={5}>
                  <MdSyncDisabled />
                </Icon>
              </Tooltip>
            </Box>
          )}
          <CardTitle domainObject={entity} name="name" fontSize={useBreakpointValue({ base: 'lg', md: 'xl' })} />
        </Box>
      </Stack>
    </PageHeaderSection>
  )
}

export default Header
